import { render, staticRenderFns } from "./Hours.vue?vue&type=template&id=c63e7b96"
import script from "./Hours.vue?vue&type=script&lang=js"
export * from "./Hours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports